module.exports = __webpack_public_path__ + "static/media/arrow-square-up.73943af4.svg";